// @flow
import { ItSendStatsActionTypes } from './constants';

type ItSendStatsAction = { type: string, payload: {} | string };

// common success
export const itSendStatsApiResponseSuccess = (actionType: string, data: any): ItSendStatsAction => ({
    type: ItSendStatsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const itSendStatsApiResponseError = (actionType: string, error: string): ItSendStatsAction => ({
    type: ItSendStatsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getItSendStat = (id: string): ItSendStatsAction => ({
    type: ItSendStatsActionTypes.GET_IT_SEND_STAT,
    payload: { id },
});

export const sendMail = (itSendStat:any):ItSendStatsAction=>({
    type:ItSendStatsActionTypes.IT_SEND_MAIL,
    payload:itSendStat
})

export const addItSendStat = (itSendStat:any):ItSendStatsAction=>({
    type:ItSendStatsActionTypes.ADD_IT_SEND_STAT,
    payload:itSendStat
})
export const updateItSendStat = (itSendStat:any):ItSendStatsAction=>({
    type:ItSendStatsActionTypes.UPDATE_IT_SEND_STAT,
    payload:itSendStat
})
export const deleteItSendStat = (id:string):ItSendStatsAction=>({
    type:ItSendStatsActionTypes.DELETE_IT_SEND_STAT,
    payload:{id}
})

export const listItSendStats = (params:any): ItSendStatsAction => ({
    type: ItSendStatsActionTypes.LIST_IT_SEND_STATS,
    payload: params,
});


export const resetItSendStats = (): ItSendStatsAction => ({
    type: ItSendStatsActionTypes.RESET,
    payload: {},
});

